import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import BuildIcon from "@material-ui/icons/Build";
import InfoIcon from "@material-ui/icons/Info";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MessageIcon from "@material-ui/icons/Message";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

const styles = (theme) => ({
  titleMenuItem: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "#FFF",
    },
  },
});

const paperStyle = {
  width: 200,
};
class MenuOptions extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      Boolean(nextProps.anchorEl) !== Boolean(this.props.anchorEl) ||
      this.props.player.IdPlayer !== nextProps.player.IdPlayer
    );
  }
  render() {
    const {
      player,
      classes,
      anchorEl,
      menuClick,
      handleMenuClick,
      handleMenuClose,
      createPlayerPriv,
    } = this.props;
    return (
      <React.Fragment>
        <IconButton
          aria-label="More"
          aria-owns={anchorEl ? "long-menu" : null}
          aria-haspopup="true"
          onClick={handleMenuClick(player.IdPlayer)}
        >
          <BuildIcon color="primary" />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose(player.IdPlayer)}
          PaperProps={{
            style: paperStyle,
          }}
        >
          <MenuItem className={classes.titleMenuItem}>
            Edit {player.Player}
          </MenuItem>
          <MenuItem onClick={menuClick("more", player)}>
            <ListItemIcon>
              <InfoIcon color="primary" />
            </ListItemIcon>
            <ListItemText inset primary="More Info" />
          </MenuItem>
          <MenuItem onClick={menuClick("watch", player)}>
            <ListItemIcon>
              <VisibilityIcon color="primary" />
            </ListItemIcon>
            <ListItemText inset primary="Watch" />
          </MenuItem>
          <MenuItem onClick={menuClick("message", player)}>
            <ListItemIcon>
              <MessageIcon color="primary" />
            </ListItemIcon>
            <ListItemText inset primary="Message" />
          </MenuItem>
          <MenuItem onClick={menuClick("edit", player)}>
            <ListItemIcon>
              <EditIcon color="primary" />
            </ListItemIcon>
            <ListItemText inset primary="Edit" />
          </MenuItem>
          {createPlayerPriv && (
            <MenuItem onClick={menuClick("clone", player)}>
              <ListItemIcon>
                <FileCopyIcon color="primary" />
              </ListItemIcon>
              <ListItemText inset primary="Clone" />
            </MenuItem>
          )}
          <MenuItem onClick={menuClick("adjust", player)}>
            <ListItemIcon>
              <AttachMoneyIcon color="primary" />
            </ListItemIcon>
            <ListItemText inset primary="Adjust" />
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

MenuOptions.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  player: PropTypes.object.isRequired,
  anchorEl: PropTypes.object.isRequired,
  menuClick: PropTypes.func.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
  handleMenuClose: PropTypes.func.isRequired,
  createPlayerPriv: PropTypes.bool.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "MenuOptions",
    withTheme: true,
  })
)(MenuOptions);
